import { Flex, Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { TechnologicalTransferValidationAction } from '@/module/Author/TechnologicalTransfer/Validation/TechnologicalTransferValidationAction';
import { TechnologicalTransferValidationHistory } from '@/module/Author/TechnologicalTransfer/Validation/TechnologicalTransferValidationHistory';
import { TechnologicalTransferDeleteButton } from '@/module/Author/TechnologicalTransfer/components/TechnologicalTransferDeleteButton';

import { Content, EditButtonLink, TitleCard } from '@/core/components';

import { AuthorList } from '@feature/utils';

import { TechnologicalTransferProofAction } from './Proof';
import { TechnologicalTransfer } from './model/TechnologicalTransferTypes';

interface TechnologicalTransferViewProps {
  technologicalTransfer: TechnologicalTransfer;
}

export function TechnologicalTransferView(props: TechnologicalTransferViewProps) {
  const { technologicalTransfer } = props;
  const { title, registrationNo, type, typeName, partnerType, partnerTypeName, domain, domainName, authors } =
    technologicalTransfer;

  const { t } = useTranslation();

  return (
    <Stack>
      <Content type="full">
        <Stack gap="4px">
          <Flex justify="space-between">
            <Group>
              <Text fw="500">{title}</Text>
            </Group>
            <Group>
              <EditButtonLink
                size="xs"
                miw="100px"
              />
              <TechnologicalTransferDeleteButton technologicalTransferId={technologicalTransfer.id} />
            </Group>
          </Flex>
          <Text
            c="dimmed"
            size="sm"
          >
            {registrationNo}
          </Text>
          <TitleCard title={title} />
          <Text
            c="dimmed"
            size="sm"
          >
            {type === 'OTHER' ? typeName : t(`technologicalTransfers.typeEnum.${type}`)}, {registrationNo}
          </Text>
          <Text
            c="dimmed"
            size="sm"
          >
            {partnerType === 'OTHER' ? partnerTypeName : t(`technologicalTransfers.partnerTypeEnum.${partnerType}`)}
          </Text>
          <Text
            c="dimmed"
            size="sm"
          >
            {domain === 'OTHER' ? domainName : t(`technologicalTransfers.domainEnum.${domain}`)}
          </Text>
        </Stack>
      </Content>
      <Content type="full">
        <AuthorList authors={authors} />
      </Content>
      <TechnologicalTransferProofAction
        technologicalTransferId={technologicalTransfer.id}
        authors={authors}
      />
      <TechnologicalTransferValidationAction technologicalTransferId={technologicalTransfer.id} />
      <TechnologicalTransferValidationHistory technologicalTransferId={technologicalTransfer.id} />
    </Stack>
  );
}
